import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteDiarioDTO;
import { columnas } from "./columns";
const resource = resources.CorteDiario;
export class CorteDiarioList extends React.PureComponent {

    onImprimir = async (x: Entity) => {
        var matriz = await resource.ImprimirMatriz(x.IdRegistro);
        kea.download(kea.base64ToBlob(matriz, 'application/vnd.ms-excel'), "Matriz de corte diario.xls");
    }

    onAgregar = async () => {
        if (await kea.yesno("¿Generar corte al día de hoy?", "" + kea.formatDate(new Date()))) {
            const idUsuario = await resources.User.getIdUsuario();
            if (idUsuario != null) {
                var idCorte = await resource.GenerarCorteDia(idUsuario);
                await kea.message("Corte diario generado");
            } else {
                await kea.message("No ha iniciado sesión");
            }
        }
    }
 
    items = observeResource(resource.query);

    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Cortes diarios" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"CorteDiarioListCookieKey"} items={this.items} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cortediario/list/list.tsx